import { EditableFieldProps } from '../core-field/editable-field-json-props'

export type ReviewStatus = 'accepted' | 'rejected' | 'overridden'

export interface ReviewEdge {
  entityId: string
  entityType?: string
  displayName?: string
  deleted?: boolean
}

export interface ReviewValue {
  status?: ReviewStatus
  reason?: string
  originalValue?: any
  // Edge to the user who made the decision; written at decision time.
  reviewedBy?: ReviewEdge
}

export const DEFAULT_SUBMITTED_VALUE_LABEL = 'Submitted Value'

export const UI2_REVIEW_FIELD_DEFAULT_PROPS: Partial<UI2ReviewFieldProps> = {
  allowOverride: false,
  allowRejection: true,
}

export interface UI2ReviewFieldProps extends EditableFieldProps<ReviewValue> {
  // uiSchema fragment for the child field being reviewed.
  fieldTemplate?: any
  // Default: false.
  allowOverride?: boolean
  // Default: true.
  allowRejection?: boolean
  rejectionReasons?: string[]
  overrideReasons?: string[]
  // Label shown above the read-only child field. Default: DEFAULT_SUBMITTED_VALUE_LABEL.
  submittedValueLabel?: string
}

// "Complete" means a decision was made — reason completeness is enforced by
// JSON Schema conditionals on `acceptRejectOverrideField` in entity.json.
export function isReviewValueEmpty(value: ReviewValue | undefined): boolean {
  return !value?.status
}

